import React, {Component} from 'react';
import {connect} from "react-redux";
import windowSize from "../libs/reactWindowSize";
import uuid from "uuid/v4";
import { withScenePosition } from "../scenePosition";

class Video extends Component {

  constructor(props){
    super(props);

    this.state = {
      id:  props.id || uuid()
    };

    this.videoElement = React.createRef();

  }

  componentDidMount() {
    this.videoElement.current.play();
  }

  static getDerivedStateFromProps(props, state){
    let { src } = props;

    return {
      ...state,
      src: src
    }
  }

  render() {
    const { src } = this.state;
    const { left, top, width, height } = this.props;

    return (
      <div className={`video-wrapper`} style={{top: top, left: left, width: width, height: height}} >
        <video ref={this.videoElement} src={src} width={parseInt(width, 10)} height={parseInt(height, 10)} />
      </div>
    );
  }

}

Video.propTypes = {

};

Video.defaultProps = {

}

function mapStateToProps(state) {
  return {
    scene: state.scene,
    step: state.step,
    minitourState: state.minitour
  }
}

export default windowSize(connect(mapStateToProps)(withScenePosition(Video)));



// WEBPACK FOOTER //
// ./src/components/Video.jsx